import React, { useState } from 'react';
import { LoadingContext } from '../ChartControls/ChartControls';

// Create a provider component to manage loading state
const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  
  const contextValue = {
    isLoading,
    setLoading: (value) => setIsLoading(value)
  };
  
  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;